import { GMDialog } from '..';
import { useLocalization } from '../../../context/Localization/localization';
import { GMButton } from '../../Button';
import { DialogErrorProps } from './DialogError.types';
import css from './DialogError.module.scss';

/**
 * A Dialog component that displays an error to the user.
 *
 * @param ariaLabel - {@link DialogErrorProps.ariaLabel ariaLabel} description.
 * @param title - {@link DialogErrorProps.title title} description.
 * @param open - {@link DialogErrorProps.open open} description.
 * @param onClose - {@link DialogErrorProps.onClose onClose} description.
 * @param children - {@link DialogErrorProps.children children} description.
 */
const DialogError = ({
    ariaLabel,
    title,
    open,
    onClose,
    children,
}: DialogErrorProps) => {
    const Localization = useLocalization();

    return (
        <GMDialog
            ariaLabel={ariaLabel}
            title={title}
            open={open}
            onClose={onClose}
            className={css.error}
            actions={[
                <GMButton
                    id={Localization.ClickToCloseWindow}
                    title={Localization.ClickToCloseWindow}
                    ariaLabel={Localization.ClickToCloseWindow}
                    onClick={onClose}
                >
                    {Localization.OK}
                </GMButton>,
            ]}
        >
            {children}
        </GMDialog>
    );
};

export default DialogError;